import type { CompetitionTeamDetailed, UpdateCompetitionTeamRequest } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function updateCompetitionTeamDetails(
  competitionId: string,
  stageId: string,
  formData: UpdateCompetitionTeamRequest
): Promise<CompetitionTeamDetailed> {
  return requestApiJsonOrThrow<CompetitionTeamDetailed>(
    `admin/competitions/${competitionId}/competition-teams/${stageId}`,
    {
      method: 'PATCH',
      body: formData,
    }
  )
}
